export class VehicleIncomeReportFilter {
    vehicleId: number;
    tripDateFrom: string;
    tripDateTo: string;
    isPaid?: boolean;
    isDeposited?: boolean;
}


// WEBPACK FOOTER //
// ./src/app/models/vehicles/vehicle.income.report.filter.ts